module.exports = "/static/pdf/MY-Merchant-Contract.b78f77cca82905ed03cf38cd39311643.pdf";